import Styles from './Banner.styles';

export const BannerSkeleton = () => {
  return (
    <Styles.ImageWrapper>
      <Styles.ImageSkeleton />
    </Styles.ImageWrapper>
  );
};
